const getCompleteName = (user) => `${user.name} ${user.lastname} `;

export default getCompleteName;
